var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { LibraryRootComponent } from "./Library";
import LibraryLayout from "./LibraryLayout";
import DocumentsList from "./components/DocumentsList";
import { withRouter } from "../componentWrappers";
import { trackPage } from "../App/GoogleAnalytics";
import { requestState } from "./helpers/requestState";

class LibraryCardsComponent extends LibraryRootComponent {
  static async requestState(requestParams, globalResources) {
    return requestState(requestParams, globalResources);
  }

  render() {
    trackPage();
    return (/*#__PURE__*/
      _jsx(LibraryLayout, {
        sidePanelMode: this.props.sidePanelMode,
        scrollCallback: this.scrollCallback,
        scrollCount: this.state.scrollCount }, void 0, /*#__PURE__*/

      _jsx(DocumentsList, {
        storeKey: "library",
        CollectionViewer: this.props.viewer,
        zoomIn: this.zoomIn,
        zoomOut: this.zoomOut,
        scrollCount: this.state.scrollCount }
      )
      ));

  }
}

const SSRLibraryComponent = withRouter(LibraryCardsComponent);

const LibraryCards = Object.assign(SSRLibraryComponent, {
  requestState: LibraryCardsComponent.requestState
});

export { LibraryCardsComponent };
export { LibraryCards };